// src/App.js
import React from 'react';
import Header from './components/Header';
import Banner from './components/Banner';
import './index.css';
import Service from './components/Service';
import Cases from './components/Cases';
import About from './components/About';
import Contact from './components/Contact';
import Footer from './components/Footer';

function App() {
  return (
    <div>
      <Header />
      <Banner />
      <About />
      <Service />
      <Cases />
      <Contact />
      <Footer />
    </div>
  );
}

export default App;
